import { __awaiter } from "tslib";
import { useAemConfig } from '@as-react/common-components';
import { wishlistMutations } from '@as-react/common-queries';
import { useMutation } from '@tanstack/react-query';
import LocalStorageUtil from '../util/LocalStorageUtil';
import { LOCAL_STORAGE_WISH_LIST_KEY } from '../constants/StorageKeysConstants';
export const useWishlist = () => {
    const { defaultRequestParams, servicesEndpoint, authenticationConfig } = useAemConfig();
    const { wishlistLoginMutation, wishlistLogoutMutation } = wishlistMutations({
        servicesEndpoint,
        defaultRequestParams,
    });
    const { mutateAsync: wishlistLogin } = useMutation(wishlistLoginMutation());
    const { mutateAsync: wishlistLogout } = useMutation(wishlistLogoutMutation());
    const login = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield wishlistLogin(authenticationConfig);
            LocalStorageUtil.removeItem(LOCAL_STORAGE_WISH_LIST_KEY);
        }
        catch (_a) { }
    });
    const logout = () => __awaiter(void 0, void 0, void 0, function* () {
        try {
            yield wishlistLogout(authenticationConfig);
            LocalStorageUtil.removeItem(LOCAL_STORAGE_WISH_LIST_KEY);
        }
        catch (_a) { }
    });
    return { wishlistLogin: login, wishlistLogout: logout };
};
